import { render, staticRenderFns } from "./PromptTemplatesPanel.vue?vue&type=template&id=1bef6e3e&scoped=true&"
import script from "./PromptTemplatesPanel.vue?vue&type=script&lang=js&"
export * from "./PromptTemplatesPanel.vue?vue&type=script&lang=js&"
import style0 from "./PromptTemplatesPanel.vue?vue&type=style&index=0&id=1bef6e3e&lang=scss&scoped=true&"
import style1 from "./PromptTemplatesPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef6e3e",
  null
  
)

export default component.exports